import React from 'react';
import { Icon } from '@iconify/react/dist/iconify.js';
import TicketCard from '../tickets/ticketCard';

const TicketsTab = ({ 
  tickets, 
  searchQuery 
}) => {
  console.log('TicketsTab render:', { ticketsLength: tickets?.length, tickets: tickets });
  
  if (!tickets || tickets.length === 0) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-center">
          <Icon icon="material-symbols:search-off" className="text-6xl text-bgAccent mb-4" />
          <p className="text-font-secondary text-lg">No tickets found for "{searchQuery}"</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-1 w-full min-h-0 overflow-hidden">
      {/* Tickets List */}
      <div className="flex flex-col w-full transition-all duration-300 ease-out overflow-hidden">
        <div className="w-full h-full flex flex-col">
          {/* Tickets Grid */}
          <div className="flex-1 overflow-y-auto scrollable p-2 -m-2">
            <div className="grid grid-cols-1 gap-2">
              {tickets.map((ticket) => (
                <TicketCard
                  key={ticket.id}
                  ticket={ticket}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TicketsTab;
